// extracted by mini-css-extract-plugin
module.exports = {"langWrapper":"styles_langWrapper__L70ZJ","container":"styles_container__IWba6"};